export default __webpack_public_path__ + "static/media/logo_aeon.769d39f9.svg";